export default __webpack_public_path__ + "images/Y9.15e9eb0.png";